import { Box, useMediaQuery } from '@mui/material';
import { Location, useLocation } from 'react-router';

import { FullScreenContainer } from '@/components/common/FullScreenContainer';
import { UploaderCard } from '@/components/common/UploaderCard';
import TopNavBar from '@/components/navigation/TopNavBar';
export interface UploaderLocationState {
  hideTopNav?: boolean;
}

const Uploader = () => {
  const location = useLocation() as Location<UploaderLocationState | undefined>;
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const hideTopNav = location.state?.hideTopNav || isMobile;

  return (
    <FullScreenContainer
      transparentBackground={!hideTopNav}
      sx={{
        justifyContent: 'flex-start',
        gap: { sm: 5, lg: 5 },
      }}>
      {!hideTopNav && <TopNavBar />}

      <Box
        sx={(theme) => ({
          width: { sm: `calc(100% + ${theme.spacing(6)})`, md: 'auto' },
          display: 'flex',
          flexGrow: 1,
          alignItems: 'center',
          backgroundColor: { sm: 'background.paper', md: 'transparent' },
        })}>
        <UploaderCard sx={{ pt: { md: 7 } }} />
      </Box>
    </FullScreenContainer>
  );
};

export default Uploader;
